<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>备用金使用说明:<br>
					<span>1、单号构成规则:NBY+201201+4位顺序号。系统生成,添加无效</span><br>
					<span>2、提交后递交给财务审核。</span><br>
					<span>3、查询关键字:单号、申请人、申请日期、收款人、状态。</span><br>
				</h5>
			</div>
		</div>
		<!-- 主+明细 -->
		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			<template slot="pre_base_button">
				<button class="pre_btn_ok" @click="edit_mode('history_sel')">选择历史报销单</button>
			</template>
			<template slot="pre_tan_button">
				<button class="pre_btn_ok" @click="edit_mode('history_sel')">选择历史报销单</button>
			</template>
		</pre-base>
		<paysel ref="paysel"></paysel>
	</div>
</template>

<script>
	// import {
	// 	GetShort
	// } from '@/utils/localstore.js';

	export default {
		components: {
			"pre-base": () => import("../auto/auto_view_v2.vue"),
			'paysel': () => import("./tan_pay_sel.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',

				// 组件
				show_tan: '0',
				show_item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				// let udata = GetShort('userdata');
				// let rname = '';
				// if (typeof(udata) !== 'undefined' && udata != '') {
				// 	let r = JSON.parse(udata);
				// 	rname = r[0].rname;
				// }
				// console.log('当前角色:' + rname);

				this.init_data = '';
				this.init_data = JSON.stringify({
					"control": "petty_cash_off",
					"title": "备用金销账",
					"isTwo": "0",
					"isTwoDetail": "0",
					"action_flag": "",
					"isFileMain": "1",
					"step": "1",
					"sel_action": 'exp_dtys_byj_off_m',
					"upd_action": 'exp15_dtys_byj_off_m',
					"detail_part": "1",
					"detail_excelup": "1",
					"d_btn_more": "0",
					"d_sel_action": 'exp_dtys_byj_off_d',
					"d_upd_action": '_dtys_byj_off_d',
					"file_action": 'filemore',
					"p1": 'ys',
					"p2": 'dtxz',
					"p3": '',
					"parm_sel": [{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"sel": "1"
						},
						{
							"name": "申请人",
							"val": "",
							"key": "u_name",
							"type": "select",
							"class": "long1",
							"sel_action": "data_alluser",
							"sel_name": "",
							"sel_val": {},
							"sel": "2"
						},
						{
							"name": "申请日期",
							"val": "",
							"key": "pay_date",
							"type": "date",
							"class": "long1",
							"sel": "3"
						},
						{
							"name": "状态",
							"val": "",
							"key": "flag",
							"type": "select",
							"class": "long1",
							"sel_action": "data_flag",
							"sel_name": "",
							"sel": "4"
						}
					],
					"parm": [{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "申请人",
							"val": "",
							"key": "u_id",
							"type": "select",
							"class": "long1",
							"sel_action": "data_alluser",
							"sel_name": "",
							"sel_val": {},
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "申请日期",
							"val": "",
							"key": "p_date",
							"type": "date",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "销账金额",
							"val": "",
							"key": "p_amount",
							"type": "label",
							"class": "black",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "1"
						},
						{
							"name": "审核通过",
							"val": "",
							"key": "amount_in",
							"type": "label",
							"class": "red",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "1"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long3",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						}
					],
					"parm_th": [{
							"name": "序号"
						},
						{
							"name": "业务单号"
						},
						{
							"name": "申请人"
						},
						{
							"name": "申请日期"
						},
						{
							"name": "销账金额"
						},
						{
							"name": "审核金额"
						},

						{
							"name": "备注",
							"class": "long2"
						},
						{
							"name": "状态"
						},
						{
							"name": "修改人"
						},
						{
							"name": "更新时间"
						}
					],
					"d_parm": [{
							"name": "业务单号",
							"val": "",
							"key": "sheet_no",
							"type": "none",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "费用名称",
							"val": "",
							"key": "pay_name",
							"type": "select",
							"class": "long1",
							"sel_action": "data_base_byj_pay",
							"sel_name": "",
							"sel_val": {},
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "金额",
							"val": "",
							"key": "pay_amount",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "1",
							"r": "0",
							"x": "1"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long2",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						}
					],
					"d_name": [{
							"name": "ID"
						},
						{
							"name": "序号"
						},
						{
							"name": "业务单号"
						},
						{
							"name": "引入单号"
						},
						{
							"name": "费用名称"
						},
						{
							"name": "金额"
						},
						{
							"name": "备注",
							"class": "long2"
						},
						{
							"name": "附件"
						},
						{
							"name": "修改人",
							"class": "short0"
						},
						// {
						// 	"name": "路径1"
						// },
						// {
						// 	"name": "路径2"
						// },
						{
							"name": "更新时间",
							"class": "long2"
						}
					]

				});



				// console.log(this.$refs);
				// this.$refs.mybase.load_data();
				// 解决偶尔第一次没有加载完成时再次 调用一下
				// var that = this;
				// this.$nextTick(function() {
				// 	that.$refs.mybase.load_data();
				// });

			},
			refresh_data: function() {

				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data('1');
				});
			},
			refresh_father: function(type, val, parm) {
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			},
			edit_mode: async function(type) {
				let sheet_no = '';
				for (let i = 0; i < this.item.length; i++) {
					// console.log(this.item[i].key + '=' + this.item[i].val);
					if (this.item[i].key == 'sheet_no') {
						sheet_no = this.item[i].val;
					}
				}

				if (sheet_no == '') {
					this.$message({
						message: '请先选择一条报账单号再开始引入历史报销信息!',
						type: 'success'
					});
					return;
				}

				let o = {};
				o.sheet_no = sheet_no;

				let that = this;
				this.$nextTick(function() {
					that.$refs['paysel'].showpop(o);
				});
			}




		}
	};
</script>
<style>
</style>